module.exports = __webpack_public_path__ + "static/media/get-recommendations-tabletPro-en.8b6a4c72.png";